import { type ColorSchemePreference } from '@/ui/theme/types/ColorSchemePreference';
import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const colorSchemePreferenceState =
  createAtomState<ColorSchemePreference>({
    key: 'colorSchemePreferenceState',
    defaultValue: 'system',
    persistInLocalStorage: true,
  });
